import { render, staticRenderFns } from "./dayi.vue?vue&type=template&id=25be1626&scoped=true&"
import script from "./dayi.vue?vue&type=script&lang=js&"
export * from "./dayi.vue?vue&type=script&lang=js&"
import style0 from "./dayi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dayi.vue?vue&type=style&index=1&id=25be1626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be1626",
  null
  
)

export default component.exports